import { pricingTypes } from 'app/modules/Constants';
import { format } from 'date-fns';
import { FC } from 'react';
import { connect } from 'react-redux';
import Helper from '../../modules/Helper';

type FlightDetailCardProps = {
	ticketData: any;
};
const FlightDetailCard: FC<FlightDetailCardProps> = (props) => {
	const { ticketData } = props;

	const getReturnInfo = () => {
		if (ticketData.hasOwnProperty('return-time')) {
			const returnTime = new Date(ticketData['return-time']);

			return (
				<>
					<div>
						<span className="location">
							{ticketData['destination-iata']} - {ticketData['origin-iata']}
						</span>
						<span className="date">{format(returnTime, ' DD MMMM YYYY')}</span>
					</div>
				</>
			);
		}
		return <></>;
	};

	if (Helper.isEmpty(ticketData)) {
		return <></>;
	}

	const departureTime = new Date(ticketData['departure-time']);

	return (
		<div id="detail-card">
			<h3 id="title">{Helper.trans('keywords.ticketDetails')}</h3>
			<div className="mt-3 mb-3">
				<div>
					<span className="location">
						{ticketData['origin-iata']} - {ticketData['destination-iata']}
					</span>
					<span className="date">{format(departureTime, ' DD MMMM YYYY')}</span>
				</div>
				{getReturnInfo()}
			</div>

			<div>
				<span className="price-type">{Helper.searchByValue(pricingTypes, ticketData['cabin-class']).label}</span>
			</div>
		</div>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	ticketData: state.passthru.ticketData,
});
export default connect(mapStateToProps, {})(FlightDetailCard);
